(() => {
  const help = {
    devis: ['Décrivez votre projet. Nous vous aiderons à choisir la bonne configuration.', 'Produit ou référence', 'Modèle, référence ou lien vers le produit', 'Votre usage, les pièces à travailler, les dimensions ou contraintes à prendre en compte…', 'Demander mon devis'],
    conseil: ['Décrivez votre besoin, même si vous n’avez pas encore choisi de machine.', 'Produit ou référence', 'Nom du produit, référence ou lien vers sa fiche', 'Que souhaitez-vous réaliser ? Quelles sont vos contraintes ?', 'Envoyer ma demande'],
    commande: ['Précisez votre numéro de commande si vous le connaissez.', 'Produit ou référence', 'Produit concerné, si nécessaire', 'Quelle est votre question sur la commande ou la livraison ?', 'Envoyer ma demande'],
    sav: ['Indiquez les informations disponibles sur votre machine pour faciliter la prise en charge.', 'Modèle ou numéro de série', 'Modèle de la machine ou numéro de série', 'Décrivez le problème, quand il se produit et les vérifications déjà effectuées.', 'Contacter le SAV'],
    rappel: ['Indiquez votre téléphone et vos disponibilités dans le message. Nous rappelons du lundi au vendredi, de 8 h à 17 h.', 'Produit ou référence', 'Le produit concerné, si nécessaire', 'Quel est votre besoin et à quel moment préférez-vous être rappelé ?', 'Demander un rappel'],
    autre: ['Dites-nous simplement comment nous pouvons vous aider.', 'Référence utile', 'Produit, commande ou autre référence si nécessaire', 'Votre demande…', 'Envoyer ma demande']
  };
  const clean = (value, max) => (value || '').replace(/[\u0000-\u001f\u007f]/g, ' ').trim().slice(0, max);
  const init = (root) => {
    if (root.dataset.contactReady) return;
    root.dataset.contactReady = 'true';
    const fields = root.querySelector('.mp-contact__fields');
    if (!fields) return;
    const reference = root.querySelector('[data-reference]');
    const body = root.querySelector('textarea[name="contact[body]"]');
    const inputs = [...root.querySelectorAll('[data-motif]')];
    const form = fields.closest('form');
    const submit = root.querySelector('[data-submit]');
    const syncSubmit = () => {
      form.querySelectorAll('input:not([type=radio]):not([type=checkbox]):not([type=hidden]), textarea').forEach(field => {
        field.setCustomValidity(field.required && field.value && !field.value.trim() ? 'Veuillez renseigner ce champ.' : '');
      });
      submit.disabled = ![...form.elements].filter(field => field.willValidate).every(field => field.validity.valid);
    };
    const params = new URLSearchParams(window.location.search);
    const hasErrors = fields.dataset.hasErrors === 'true';
    const product = clean(params.get('produit'), 180);
    const requested = params.get('motif');
    if (!hasErrors) {
      const motif = Object.hasOwn(help, requested) ? requested : (product ? 'devis' : null);
      if (motif) inputs.find(input => input.dataset.motif === motif).checked = true;
      if (product && !reference.value) reference.value = product;
      const context = root.querySelector('[data-context]');
      if (product) { context.textContent = `Votre demande concerne : ${product}`; context.hidden = false; }
      const source = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content'].map(key => {
        const value = clean(params.get(key), 100);
        return value ? `${key}: ${value}` : '';
      }).filter(Boolean).join(' | ');
      if (source) root.querySelector('[data-origin]').value = source;
    }
    const update = () => {
      const selected = inputs.find(input => input.checked)?.dataset.motif || 'conseil';
      const [description, label, placeholder, message, button] = help[selected];
      root.querySelector('[data-topic-help]').textContent = description;
      root.querySelector('[data-sav-help]').hidden = selected !== 'sav';
      root.querySelector('[data-reference-label]').textContent = label;
      reference.placeholder = placeholder;
      body.placeholder = message;
      const needsOrder = selected === 'commande' || selected === 'sav';
      root.querySelector('[data-order-field]').hidden = !needsOrder;
      root.querySelector('[data-order]').disabled = !needsOrder;
      root.querySelector('input[type=tel]').required = selected === 'rappel';
      root.querySelector('[data-phone-note]').textContent = selected === 'rappel' ? '*' : 'facultatif';
      root.querySelector('[data-submit]').firstChild.textContent = `${button} `;
      syncSubmit();
    };
    form.addEventListener('input', syncSubmit);
    form.addEventListener('change', syncSubmit);
    form.addEventListener('focusin', syncSubmit);
    form.addEventListener('reset', () => queueMicrotask(() => { update(); syncSubmit(); }));
    form.addEventListener('submit', event => {
      syncSubmit();
      if (submit.disabled) event.preventDefault();
    });
    window.addEventListener('pageshow', syncSubmit);
    inputs.forEach(input => input.addEventListener('change', update));
    root.querySelector('[data-choose-rappel]').addEventListener('click', () => {
      inputs.find(input => input.dataset.motif === 'rappel').checked = true;
      update();
      const phone = root.querySelector('input[type=tel]');
      phone.focus();
      phone.scrollIntoView({ block: 'center' });
    });
    update();
  };
  document.querySelectorAll('[data-mp-contact]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-mp-contact]').forEach(init));
})();
